/** Meilensteine aller Projekte (F-25), live und nach dem Bereichsfilter. */
import { useLiveQuery } from 'dexie-react-hooks';
import { useMemo } from 'react';

import { db } from '@/db/schema';
import { meilensteinItems, type MeilensteinItem } from '@/domain/projects/meilensteine';
import { useAreaFilter } from '@/store/areaFilter';

export function useMeilensteine(): MeilensteinItem[] {
  const { activeAreaIds } = useAreaFilter();
  const alle = useLiveQuery(async () => meilensteinItems(await db.projects.toArray()), [], [] as MeilensteinItem[]);
  return useMemo(
    () => (activeAreaIds.length === 0 ? alle : alle.filter((m) => m.areaId != null && activeAreaIds.includes(m.areaId))),
    [alle, activeAreaIds],
  );
}
